import React, { useState } from "react";
import LogoButton from "./LogoButton";
// import AppButton from "./AppButton";
import SearchButton from "./SearchButton";
import MenuButton from "./MenuButton";
import { Menu } from "../UI/Menu";
import { ArchiveSection } from "../layout/ArticlesPage";
import CloseImage from "../../assets/popup/close.svg";

const HeaderComponents = ({ allPosts }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const toggleMenu = () => {
    if (isMenuOpen == true) {
      setIsMenuOpen(false);
    } else if (isMenuOpen == false) {
      setIsMenuOpen(true);
    }
  };

  return (
    <header className="bg-beige-prim shadow-md w-full flex items-center fixed top-0 left-0 z-30 px-4 md:px-20">
      {/* Container for LogoButton */}
      <div className="flex-1 flex justify-center md:justify-start">
        <LogoButton />
      </div>

      {/* Container for SearchButton & MenuButton (Always aligned to the right) */}
      <section className="flex gap-4 ml-auto ">
        <SearchButton toggleSearch={toggleSearch} />
        <MenuButton toggleMenu={toggleMenu} />
      </section>
      <Menu toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
      <div
        style={isSearchOpen ? {} : { display: "none" }}
        className="bg-beige-prim shadow-md w-full h-full flex flex-col items-center fixed top-0 left-0 z-30 p-4 overflow-y-auto"
      >
        <button className="ml-auto mr-[10vw]" onClick={toggleSearch}>
          <img src={CloseImage} className="w-10" />
        </button>
        <ArchiveSection allPosts={allPosts} toggleSearch={toggleSearch} />
      </div>
    </header>

    // <header className="bg-beige-prim shadow-md w-full flex items-center justify-between z-30 md:justify-start md:px-20 fixed top-0 left-0">
    //   <LogoButton />
    //   {/* <AppButton /> */}
    //   <section className="flex gap-4 md:ml-auto">
    //     <SearchButton />
    //     <MenuButton toggleMenu={toggleMenu} />
    //   </section>
    //   <Menu toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
    // </header>
  );
};

export default HeaderComponents;
